import React from "react";
import "./about.css"; // Import the CSS file
import Header from "../Header"; // Assuming this is your pre-built Header component
import Footer from "../Footer"; // Assuming this is your pre-built Footer component
import { Box, Typography } from "@mui/material";

const SocialService = () => {
  const sections = [
    {
      image: "Images/About/ss1.png",
      text: "At JAMIA NIDA-E-ISLAM, education goes beyond the classroom, embracing a strong commitment to social service and community engagement. The institution firmly believes that the true value of knowledge lies in its ability to serve and uplift others. This vision is deeply embedded in the school's culture, where students, educators, and staff are encouraged to actively participate in initiatives that benefit the broader society.",
    },
    {
      image: "Images/About/ss2.png",
      text: "Through various social service programs and outreach activities, JAMIA NIDA-E-ISLAM teaches students the importance of giving back and developing a sense of social responsibility. Whether it is organizing community clean-up drives, collecting donations for underprivileged families, or assisting in educational outreach programs, JAMIA NIDA-E-ISLAM provides students with ample opportunities to engage in service-learning experiences.",
    },
    {
      image: "Images/About/ss3.png",
      text: "In addition to these student-led initiatives, JAMIA NIDA-E-ISLAM also partners with various local organizations and community groups to support a wide range of causes. These collaborations enhance the school's efforts in providing direct aid to those in need, especially in areas related to education, health, and poverty alleviation.",
    },
    {
      image: "Images/About/ss4.png",
      text: "Despite its continuous development, JAMIA NIDA-E-ISLAM remains dedicated to making a difference in the lives of others. The school’s ongoing commitment to social service ensures that students not only graduate with knowledge but also with a deep understanding of their role in shaping a better and more equitable society.",
    },
  ];

  return (
    <div className="about-education">
      <Header />
      <main className="content">
        {/* Hero Section */}
        <section className="hero">
          <img
            src="Images/About/header.png"
            alt="Background"
            className="hero-image"
            
          />
          <div className="overlay">
            <h1 className="title">
              Social<br />Service
            </h1>
          </div>
        </section>

        {/* Content Section */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 2,
            padding: "16px",
            marginX: { xs: "16px", md: "50px" },
          }}
        >
          {sections.map((section, index) => (
            <Box
              key={index}
              sx={{
                display: "flex",
                flexDirection: {
                  xs: "column", // Stack vertically on small screens
                  sm: "row", // Use row/row-reverse from medium screens onward
                  md: index % 2 === 0 ? "row" : "row-reverse",
                },
                gap: 3,
                alignItems: "center",
                padding: "16px",
                backgroundColor: "#f9f9f9",
                borderRadius: "8px",
                boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
              
              }}
            >
              <Box
                component="img"
                src={section.image}
                alt={`Section ${index}`}
                sx={{
                  flex: 1,
                  width: "100%",
                  maxWidth: { xs: "100%", sm: "40%", md: "25%" }, // Adjust max width per screen size
                  height: "auto", // Maintain aspect ratio
                  borderRadius: "8px",
                  boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                }}
              />
              <Typography
                variant="body1"
                sx={{
                  flex: 2,
                  fontSize: { xs: "1rem", sm: "1.1rem" },
                  textAlign: "justify",
                  color: "#555",
                }}
              >
                {section.text}
              </Typography>
            </Box>
          ))}
        </Box>
      </main>
      <Footer />
    </div>
  );
};

export default SocialService;
